__turbopack_context__.v({
  "hasIcon": "IconButton-module__2KjMVG__hasIcon",
  "iconButton": "IconButton-module__2KjMVG__iconButton",
  "iconOnly": "IconButton-module__2KjMVG__iconOnly",
  "iconSlot": "IconButton-module__2KjMVG__iconSlot",
});
